export class ItemSubCategoryRequest{
    itemSubCategoryId:number;
    
    constructor(itemSubCategoryId:number){
        this.itemSubCategoryId = itemSubCategoryId;
    }
}